var $a79794784d61577c$exports = {};
$a79794784d61577c$exports = {
  "buttonLabel": "\xD6nerileri g\xF6ster",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " se\xE7enek");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " se\xE7enekler");
      }
    }), " kullan\u0131labilir.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Girilen grup ".concat(args.groupTitle, ", ile ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " se\xE7enek");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " se\xE7enekler");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", se\xE7ildi",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\xD6neriler",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", se\xE7ildi");
  }
};
export { $a79794784d61577c$exports as default };